<template>
  <div class="container-fluid" id="commentsPage">
    <page-title
      :isDataLoading="isDataLoading"
      :title="this.$t('comments')"
      iconClasses="fas fa-comments"
      :isTimelineDisplayed="true"
    />

    <div class="row comment ml-3 mr-3">
      <form-controls
        v-if="controlsConfig && controlsConfig.length > 0"
        :controls="controlsConfig"
        :displayConfig="{
          toggleableGroups: ['filters'],
        }"
        v-on:updateControl="handleFormControlChange"
        v-on:setDefaultValues="setFormControlsDefault"
      />
    </div>

    <div class="container-fluid mt-2" v-if="downloaded">
      <div class="row">
        <div class="col mt-3">
          <label>
            <strong>{{ result.totalCount }}</strong>
            {{ $t('comments_found') }}
          </label>
        </div>
        <div class="col">
          <nav aria-label="Page comment navigation">
            <paginate
              v-model="currentPage"
              :page-count="Number(result.totalPage)"
              :page-range="3"
              :margin-pages="2"
              :click-handler="onChangeCommentsPage"
              :prev-text="'&laquo;'"
              :next-text="'&raquo;'"
              :container-class="'pagination justify-content-end'"
              :page-class="'page-item'"
              :page-link-class="'page-link'"
              :prev-link-class="'page-link'"
              :next-link-class="'page-link'"
            ></paginate>
          </nav>
        </div>
      </div>
    </div>

    <div class="container-fluid" v-if="!isSmartphoneDevice && !isSmallScreen && !isMediumScreen">
      <table class="table mt-2 h-100" id="commentsTable">
        <thead>
          <tr>
            <th scope="col" class="text-center align-middle">
              {{ $t('date') }}
            </th>
            <th scope="col" class="text-center align-middle">
              {{ $t('comment') }}
            </th>
            <th scope="col" class="text-center align-middle">
              {{ $t('filter.histopad_rating') }}
            </th>
            <th scope="col" class="text-center align-middle">
              {{ $t('filter.visit_rating') }}
            </th>
            <th
              scope="col"
              class="text-center align-middle"
              v-if="getCurrentUser.userRole.name === 'administrator' && formControl.displayLiteracy"
            >
              {{ $t('filter.quality') }}
            </th>
            <th
              scope="col"
              class="text-center align-middle"
              v-if="
                getCurrentUser.userRole.name !== 'partner' ||
                  (getCurrentUser.userRole.name === 'partner' && getCurrentUser.sites.length > 1)
              "
            >
              {{ $t('site.title') }}
            </th>
            <th
              scope="col"
              class="text-center align-middle"
              v-if="getCurrentUser.userRole.name !== 'partner'"
            >
              {{ $t('share') }}
            </th>
            <th scope="col" class="text-center align-middle">
              {{ $t('lists') }}
            </th>
          </tr>
        </thead>
        <tbody v-if="downloaded">
          <tr v-for="(comment, index) in result.comments" :key="index">
            <th scope="row" class="text-center">
              {{ formatDateTime(comment.start_time) }}
            </th>
            <td v-if="getCurrentUser.userRole.name !== 'partner'">
              <a style="color: #feffe9" :href="`/session/${comment.session_id}`">{{
                comment.comment[0].text
              }}</a>
            </td>
            <td v-if="getCurrentUser.userRole.name === 'partner'">
              {{ comment.comment[0].text }}
            </td>
            <td class="text-center" :class="chooseStarsColor(comment.histopad_rating)">
              <i class="fas fa-star" v-for="index in comment.histopad_rating" :key="index"></i>
            </td>
            <td class="text-center" :class="chooseStarsColor(comment.visit_rating)">
              <i class="fas fa-star" v-for="index in comment.visit_rating" :key="index"></i>
            </td>
            <td
              class="text-center score-quality"
              v-if="getCurrentUser.userRole.name === 'administrator' && formControl.displayLiteracy"
              v-tooltip="{
                content: `Score : ${comment.comment[0].score}`,
                placement: 'top-center',
              }"
            >
              <i :class="chooseScoreIcon(comment.comment[0].score)"></i>
            </td>
            <td
              class="text-center"
              v-if="
                getCurrentUser.userRole.name !== 'partner' ||
                  (getCurrentUser.userRole.name === 'partner' && getCurrentUser.sites.length > 1)
              "
            >
              {{ getLocalizedSiteName(comment.site_location) }}
            </td>
            <td class="text-center" v-if="getCurrentUser.userRole.name !== 'partner'">
              <button
                type="button"
                class="btn btn-chart"
                data-toggle="modal"
                data-target="#shareCommentToUserModal"
                @click="fillShareComment(comment)"
              >
                <i class="fas fa-share-alt"></i>
              </button>
            </td>
            <td class="text-center">
              <button
                type="button"
                class="btn btn-chart"
                data-toggle="modal"
                data-target="#editBookmarkListModal"
                @click="fillEditBookmarkLists(comment)"
              >
                <i class="fas fa-plus"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="isSmartphoneDevice || isSmallScreen || isMediumScreen" class="mt-2">
      <div
        class="container-fluid rounded p-3 mb-3 btn-chart"
        v-for="(comment, index) in result.comments"
        :key="index"
      >
        <div class="row" style="font-size: 0.6rem">
          <div class="col">
            <span>
              {{ $t('the') }}
              <strong>{{ formatDateTime(comment.start_time) }}</strong>
              -
              <strong>{{ getLocalizedSiteName(comment.site_location) }}</strong> </span
            >&nbsp;&nbsp;
            <span>
              <i class="fas fa-star" v-for="index in comment.histopad_rating" :key="index"></i>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <span>{{ comment.comment[0].text }}</span>
          </div>
        </div>
        <div class="row justify-content-end">
          <div class="col-auto mt-2">
            <button
              v-if="getCurrentUser.userRole.name !== 'partner'"
              type="button"
              class="btn btn-chart-dark btn-sm"
              data-toggle="modal"
              data-target="#shareCommentToUserModal"
              @click="fillShareComment(comment)"
            >
              <i class="fas fa-share-alt"></i>
            </button>
            <button
              type="button"
              class="btn btn-chart-dark btn-sm ml-1"
              data-toggle="modal"
              data-target="#editBookmarkListModal"
              @click="fillEditBookmarkLists(comment)"
            >
              <i class="fas fa-plus"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid mt-2" v-if="downloaded">
      <div class="row">
        <div class="col">
          <button class="btn btn-chart mb-3" @click="downloadComments">
            {{ $t('download.comments') }}
            <i class="ml-2 fas fa-download"></i>
          </button>
        </div>
        <div class="col">
          <nav aria-label="Page comment navigation">
            <paginate
              v-model="currentPage"
              :page-count="Number(result.totalPage)"
              :page-range="3"
              :margin-pages="2"
              :click-handler="onChangeCommentsPage"
              :prev-text="'&laquo;'"
              :next-text="'&raquo;'"
              :container-class="'pagination justify-content-end'"
              :page-class="'page-item'"
              :page-link-class="'page-link'"
              :prev-link-class="'page-link'"
              :next-link-class="'page-link'"
            ></paginate>
          </nav>
        </div>
      </div>
    </div>

    <!-- Modal use to edit bookmark list for user -->
    <div
      class="modal fade"
      id="editBookmarkListModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="editBookmarkListLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editBookmarkListLabel">
              {{ $t('add_comment') }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group row">
              <label for="email-input" class="col-form-label col-sm-12">{{
                $t('select_list')
              }}</label>
              <div class="col-sm-12">
                <select
                  id="inputUser"
                  class="custom-select"
                  v-model="bookmarkListForm.bookmarkLists"
                  multiple
                >
                  <option
                    v-for="bookmarkList in userBookmarkLists"
                    :key="bookmarkList.id"
                    :value="bookmarkList.id"
                  >
                    {{
                      bookmarkList.title == 'my_favourites' ||
                      bookmarkList.title == 'shared_with_me'
                        ? $t(bookmarkList.title)
                        : bookmarkList.title
                    }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group row justify-content-md-center">
              <button
                type="button"
                class="btn btn-light m-2 col-sm-6"
                data-dismiss="modal"
                data-toggle="modal"
                data-target="#createBookmarkListModal"
              >
                <i class="fas fa-plus"></i>&nbsp;&nbsp;Créer une liste
              </button>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              {{ $t('cancel') }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              @click="updateBookmarkLists()"
            >
              {{ $t('save') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal use to create a new list of bookmarks -->
    <div
      class="modal fade"
      id="createBookmarkListModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="createBookmarkListModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="createBookmarkListModalLabel">
              {{ $t('create_list') }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group row">
              <input
                type="title"
                v-model="newBookmarkList.title"
                class="form-control m-2"
                id="inputBookmarkList"
                placeholder="Titre de la nouvelle liste"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              {{ $t('cancel') }}
            </button>
            <button
              type="button"
              :class="
                String(newBookmarkList.title).trim().length > 0
                  ? 'btn btn-primary'
                  : 'btn btn-primary disabled'
              "
              @click="createNewBookmarkList()"
              data-dismiss="modal"
            >
              {{ $t('add_and_create') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal use to share the current dashboard -->
    <div
      class="modal fade"
      id="shareCommentToUserModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="shareCommentToUserModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="shareCommentToUserModalLabel">
              {{ $t('modal.share_comment') }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group row">
              <label for="inputUser" class="col-sm-4 col-form-label">{{
                $t('select_users')
              }}</label>
              <div class="col-sm-8">
                <select id="inputUser" class="custom-select" v-model="selectedUsers" multiple>
                  <option v-for="user in allUsers" :key="user.id" :value="user.id">
                    {{ user.email }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              {{ $t('cancel') }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              @click="onShareComment"
            >
              {{ $t('share') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment-timezone'
import Toasted from 'vue-toasted'
import { utilsMixin, chartMixin, sitesMixin } from '../utils/mixins'
import VueScrollTo from 'vue-scrollto'
import thresholds from '../assets/config/litteracy'

Vue.use(Toasted)

//Scroll to
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: -100,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
})

export default {
  name: 'Comment',
  dependencies: ['dataService', 'adminService'],
  mixins: [utilsMixin, chartMixin, sitesMixin],
  data() {
    return {
      downloaded: false,
      currentPage: this.$route.params.page ? Number(this.$route.params.page) : 1,
      comments: [],
      timeout: null,
      formControl: {
        currentPage: 1,
      },
      result: {
        page: 1,
        limit: 50,
        totalCount: 0,
        totalPage: 0,
        comments: [],
      },
      literacyThresholds: thresholds,
      bookmarkListForm: {
        user_id: 0,
        bookmarkLists: [],
      },
      userBookmarkLists: [],
      newBookmarkList: {
        user_id: -1,
        title: '',
      },
      selectedComment: null,
      selectedUsers: [],
      allUsers: [],
      controlsConfig: [],
    }
  },
  props: ['period'],
  mounted() {
    moment.tz.setDefault('UTC')
    this.newBookmarkList.user_id = this.getCurrentUser.id
    this.controlsConfig = this.generateControlsConfig()
    this.$emit('updateSite', [this.formControl.site])
    this.fetchBookmarkLists()

    // if (this.period) {
    this.fetchComments()
    //}
  },
  watch: {
    period: {
      handler() {
        this.fetchComments()
      },
      immediate: true,
    },
  },
  computed: {
    siteIDs() {
      return [this.formControl.site]
    },
  },
  components: {
    'page-title': () => import('./utils/PageTitle'),
    'form-controls': () => import('./utils/FormControls'),
  },
  methods: {
    generateControlsConfig() {
      let config = [
        {
          label: this.$t('search.keyword'),
          type: 'text',
          vModel: 'keyword',
          group: 'display',
          default: this.$route.params.keyword ? this.$route.params.keyword : '',
        },
        {
          label: this.$t('sort_by'),
          type: 'select',
          vModel: 'order',
          group: 'display',
          default: this.$route.params.order ? this.$route.params.order : 'start_time-desc',
          options: [
            {
              value: 'start_time-desc',
              label: this.$t('sort.by_date_desc'),
            },
            {
              value: 'start_time-asc',
              label: this.$t('sort.by_date_asc'),
            },
            {
              value: 'histopad_rating-desc',
              label: this.$t('sort.by_rating_desc'),
            },
            {
              value: 'histopad_rating-asc',
              label: this.$t('sort.by_rating_asc'),
            },
            {
              value: 'score-desc',
              label: this.$t('sort.by_score_desc'),
            },
            {
              value: 'score-asc',
              label: this.$t('sort.by_score_asc'),
            },
          ],
        },
        {
          label: this.$t('display_by'),
          type: 'select',
          vModel: 'count',
          group: 'display',
          default: this.$route.params.count ? this.$route.params.count : 50,
          options: [
            {
              value: 50,
              label: '50',
            },
            {
              value: 100,
              label: '100',
            },
            {
              value: 200,
              label: '200',
            },
            {
              value: 500,
              label: '500',
            },
          ],
        },
        {
          label: this.$t('display_literacy'),
          type: 'checkbox',
          vModel: 'displayLiteracy',
          group: 'display',
          default: false,
        },
        {
          label: this.$t('filter.by_site'),
          type: 'select',
          vModel: 'site',
          group: 'filters',
          default: this.$route.params.site ? this.$route.params.site : 'all',
          options: [
            {
              value: 'all',
              label: this.$t('select_all'),
            },
            ...this.getCurrentUser.sites.map(site => ({
              value: site.site,
              label: site.name,
            })),
          ],
        },
        {
          label: this.$t('filter.by_language'),
          type: 'select',
          vModel: 'language',
          group: 'filters',
          default: this.$route.params.language ? this.$route.params.language : 'all',
          options: [
            {
              value: 'all',
              label: this.$t('select_all'),
            },
            ...this.configFilterHierarchy.filter_values.language.map(lang => ({
              value: lang,
              label: this.$t(`language.${lang}`),
            })),
          ],
        },
        {
          label: this.$t('filter.by_histopad_rating'),
          type: 'select',
          vModel: 'histopad_rating',
          group: 'filters',
          default: this.$route.params.histopad_rating ? this.$route.params.histopad_rating : 'all',
          options: [
            {
              value: 'all',
              label: this.$t('select_all'),
            },
            {
              value: 0,
              label: '0',
            },
            {
              value: 1,
              label: '1',
            },
            {
              value: 2,
              label: '2',
            },
            {
              value: 3,
              label: '3',
            },
            {
              value: 4,
              label: '4',
            },
            {
              value: 5,
              label: '5',
            },
          ],
        },
        {
          label: this.$t('filter.by_visit_rating'),
          type: 'select',
          vModel: 'visit_rating',
          group: 'filters',
          default: this.$route.params.visit_rating ? this.$route.params.visit_rating : 'all',
          options: [
            {
              value: 'all',
              label: this.$t('select_all'),
            },
            {
              value: 0,
              label: '0',
            },
            {
              value: 1,
              label: '1',
            },
            {
              value: 2,
              label: '2',
            },
            {
              value: 3,
              label: '3',
            },
            {
              value: 4,
              label: '4',
            },
            {
              value: 5,
              label: '5',
            },
          ],
        },
        {
          label: this.$t('filter.by_list'),
          type: 'select',
          vModel: 'bookmarkList',
          group: 'filters',
          default: this.$route.params.list ? this.$route.params.list : 'all',
          options: [
            {
              value: 'all',
              label: this.$t('select_all'),
            },
            ...this.userBookmarkLists.map(bookmarkList => ({
              value: bookmarkList.id,
              label:
                bookmarkList.title == 'my_favourites' || bookmarkList.title == 'shared_with_me'
                  ? this.$t(bookmarkList.title)
                  : bookmarkList.title,
            })),
          ],
        },
      ]

      return config
    },
    fetchComments() {
      this.requestCount++

      let selectedSites = this.getSitesAccess()

      let start = moment(this.period[0], this.dateFormat).format('YYYY-MM-DD')

      let end = moment(this.period[1], this.dateFormat).format('YYYY-MM-DD')

      window.history.pushState(
        null,
        null,
        '/comments/page/' +
          this.formControl.currentPage +
          '/count/' +
          (this.formControl.count || '50') +
          '/site/' +
          (this.formControl.site || 'all') +
          '/language/' +
          (this.formControl.language || 'all') +
          '/histopad_rating/' +
          (this.formControl.histopad_rating || 'all') +
          '/visit_rating/' +
          (this.formControl.visit_rating || 'all') +
          '/order/' +
          (this.formControl.order || 'start_time-desc') +
          '/list/' +
          (this.formControl.bookmarkList || 'all') +
          '/start/' +
          start +
          '/end/' +
          end +
          '/keyword/' +
          (this.formControl.keyword && this.formControl.keyword !== 'undefined'
            ? this.formControl.keyword
            : ''),
      )

      VueScrollTo.scrollTo('#commentsPage')

      let config = Object.create(this.formControl)
      config.currentPage = this.currentPage
      config.sites = selectedSites || []
      config.userId = this.getCurrentUser.id
      config.date = {
        start: start,
        end: end,
      }

      this.dataService
        .getComments(config)
        .then(data => {
          this.result = data.result
          this.downloaded = true
          this.requestCount--
        })
        .catch(e => {
          console.error('Error', e)
          this.requestCount--
        })
        .catch(e => {
          console.error('Error', e)
          this.requestCount--
        })
    },
    onChangeCommentsPage() {
      this.fetchComments()
    },
    onCommentFilterChange() {
      this.formControl.score_min = this.literacyThresholds[this.formControl.litteracy].min
      this.formControl.score_max = this.literacyThresholds[this.formControl.litteracy].max
      this.currentPage = 1
      this.fetchComments()
    },
    getSitesAccess() {
      let selectedSites = this.formControl.site
      if (this.getCurrentUser.userRole.name === 'partner') {
        let found = this.getCurrentUser.sites.find(s => {
          return s.site === selectedSites
        })
        if (!found) {
          this.formControl.site = 'all'
        }

        if (this.formControl.site == 'all') {
          selectedSites = Array.from(this.getCurrentUser.sites, s => {
            return s.site
          }).join()
        }
      }
      return selectedSites
    },
    downloadComments: function() {
      VueScrollTo.scrollTo('#commentsPage')
      this.requestCount++
      if (this.getCurrentUser.userRole.name === 'partner' && this.site == 'all') {
        selectedSites = Array.from(this.getCurrentUser.sites, s => {
          return s.site
        }).join()
      }

      let selectedSites = this.getSitesAccess()

      let start = moment(this.period[0], this.dateFormat).format('YYYY-MM-DD')

      let end = moment(this.period[1], this.dateFormat).format('YYYY-MM-DD')

      this.dataService
        .downloadComments(
          this.formControl,
          selectedSites,
          this.getCurrentUser.email,
          start,
          end,
          this.$locale,
        )
        .then(data => {
          this.$log.debug('Data type', data.type)
          if (data.type === 'application/vnd.openxmlformats') {
            const url = window.URL.createObjectURL(new Blob([data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute(
              'download',
              `export_comments_${moment().format('YYYY-MM-DD_HH:mm:ss')}.xls`,
            )
            document.body.appendChild(link)
            link.click()
          } else {
            this.showToast(this.$t('download.comment_email', [this.getCurrentUser.email]))
          }

          this.requestCount--
        })
        .catch(e => {
          console.error('Error', e)
          this.requestCount--
        })
        .catch(e => {
          console.error('Error', e)
          this.requestCount--
        })
    },

    fillEditBookmarkLists(comment) {
      this.selectedComment = comment
      this.getBookmarkList()
    },

    createNewBookmarkList: function() {
      this.dataService
        .createBookmarkList(
          this.newBookmarkList.user_id,
          this.newBookmarkList.title,
          this.selectedComment.id,
        )
        .then(() => {
          this.showToast(
            this.$t('added_new_list_comment_confirmation', [this.newBookmarkList.title]),
          )
          this.newBookmarkList.title = ''
          this.fetchBookmarkLists()
        })
        .catch(error => {
          this.showToast(this.$t('add_comment_error'))
          console.error('Error', error)
        })
    },
    getBookmarkList() {
      this.dataService
        .getUserBookmarkListsForComment(this.getCurrentUser.id, this.selectedComment.id)
        .then(data => {
          this.userBookmarkLists = data.result
          this.bookmarkListForm.bookmarkLists = this.userBookmarkLists.filter(bl => {
            return bl['is_selected'] === true
          })
          this.bookmarkListForm.bookmarkLists = Array.from(
            this.bookmarkListForm.bookmarkLists,
            bl => {
              return bl.id
            },
          )
        })
        .catch(error => {
          console.error('Error', error)
        })
    },
    updateBookmarkLists() {
      this.dataService
        .addCommentToBookmarkLists(
          this.getCurrentUser.id,
          this.selectedComment.id,
          this.bookmarkListForm.bookmarkLists,
        )
        .then(() => {
          this.showToast(this.$t('added_comment_confirmation'))
          this.newBookmarkList.title = ''
        })
        .catch(error => {
          this.showToast(this.$t('add_comment_error'))
          console.error('Error', error)
        })
        .catch(error => {
          this.showToast(this.$t('add_comment_error'))
          console.error('Error', error)
        })
    },
    fetchBookmarkLists() {
      this.dataService
        .getUserBookmarkLists(this.getCurrentUser.id)
        .then(data => {
          this.userBookmarkLists = data.result
          this.controlsConfig = this.generateControlsConfig()
        })
        .catch(error => {
          console.error('Error', error)
        })
        .catch(error => {
          console.error('Error', error)
        })
    },
    showToast(text) {
      this.$toasted.show(text, {
        theme: 'toasted-primary',
        position: 'bottom-center',
        duration: 2000,
      })
    },
    fillShareComment(comment) {
      this.selectedComment = comment

      this.dataService
        .getUsersForSite(this.selectedComment.site_location)
        .then(data => {
          let users = data.result
          this.allUsers = users.filter(user => {
            return user.id != this.getCurrentUser.id
          })
        })
        .catch(e => {
          console.error('Error', e)
        })
        .catch(e => {
          console.error('Error', e)
        })
    },
    onShareComment() {
      this.dataService
        .shareComment(this.selectedComment.id, this.selectedUsers)
        .then(() => {
          this.showToast(this.$t('shared_comment_confirmation'))
        })
        .catch(e => {
          this.showToast(this.$t('add_comment_error'))
          console.error('Error', e)
        })
        .catch(e => {
          this.showToast(this.$t('add_comment_error'))
          console.error('Error', e)
        })
    },
    chooseScoreIcon(score) {
      for (let threshold of this.literacyThresholds) {
        if (score === null) {
          return ['far', 'fa-question-circle', 'fa-lg']
        } else if (score >= threshold.min && score < threshold.max) {
          return ['fas', threshold.icon, 'icon-quality-' + threshold.name]
        }
      }
    },
    chooseStarsColor(score) {
      return [
        score < 3 ? 'icon-quality-bad' : score < 5 ? 'icon-quality-medium' : 'icon-quality-good',
      ]
    },
    scoreTooltipContent(score) {
      return score === null ? this.$t('score_null') : score
    },
    handleFormControlChange(config) {
      this.formControl[config.vModel] = config.value

      if (config.vModel == 'site') {
        this.$emit('updateSite', [this.formControl.site])
      }

      window.history.pushState(
        null,
        null,
        '/comments/page/' +
          this.formControl.currentPage +
          '/count/' +
          (this.formControl.count || '50') +
          '/site/' +
          (this.formControl.site || 'all') +
          '/language/' +
          (this.formControl.language || 'all') +
          '/histopad_rating/' +
          (this.formControl.histopad_rating || 'all') +
          '/visit_rating/' +
          (this.formControl.visit_rating || 'all') +
          '/order/' +
          (this.formControl.order || 'start_time-desc') +
          '/list/' +
          (this.formControl.bookmarkList || 'all') +
          '/start/' +
          this.start +
          '/end/' +
          this.end +
          '/keyword/' +
          (this.formControl.keyword && this.formControl.keyword !== 'undefined'
            ? this.formControl.keyword
            : ''),
      )

      if (config.vModel !== 'displayLiteracy') {
        this.fetchComments()
        this.formControl.currentPage = 1
      }
    },
  },
}
</script>

<style>
.table > tbody > tr > td {
  vertical-align: middle;
}

.table > tbody > tr > th {
  vertical-align: middle;
}
</style>
